import { flexRender, getCoreRowModel, useReactTable } from '@tanstack/react-table';
import React, { useMemo } from 'react';

/**
 * IncDecTable component for displaying tabular data with conditional styling.
 *
 * @component
 * @memberof Components
 * @param {Object} props - The properties passed to the IncDecTable component.
 * @param {Array} props.data - The data to be displayed in the table.
 * @param {Array} props.columns - The column definitions for the table.
 * @param {string} [props.extend] - Optional text to append to each cell value.
 * @param {string} [props.type] - Optional dependency for re-memoizing the data and columns.
 *
 * @example
 * const data = [{ value: 10, label: "Example" }];
 * const columns = [
 *   { accessorKey: "value", header: "Value" },
 *   { accessorKey: "label", header: "Label" }
 * ];
 * 
 * <IncDecTable data={data} columns={columns} extend="%" />
 *
 * @returns {JSX.Element} A table displaying the provided data with conditional formatting.
 */
const IncDecTable = (props) => {

    const data = useMemo(() => {
        return props.data;
    }, [props.type]);

    const columns = useMemo(() => {
        return props.columns;
    }, [props.type]);


    const table = useReactTable({ data, columns, getCoreRowModel: getCoreRowModel() });

    return (
        // <div style={{ marginTop: '1%', width: 'auto', backgroundColor: '#F3F6FB', padding: '2%', borderRadius: '5px',  maxHeight: '350px', overflowY: 'auto' }}>
        <table style={{ width: "100%", borderCollapse: 'collapse' }}>
            <thead>
                {table.getHeaderGroups().map((headerGroup, index) => (
                    <tr key={index}>
                        {headerGroup.headers.map((header, index) => {
                            const isLeftAligned = index === 0;
                            const headerStyle = {
                                fontSize: '13px',
                                textAlign: 'center', // Conditionally set the textAlign
                                backgroundColor: 'white',
                                fontWeight: 'bold',
                                // border:'1px solid lightgrey'
                            };
                            return (
                                <th key={index} style={headerStyle}>
                                    <p>
                                        {flexRender(
                                            header.column.columnDef.header,
                                            header.getContext()
                                        )}
                                    </p>
                                </th>
                            )
                        })}
                    </tr>
                ))}
            </thead>
            <tbody style={{ maxHeight: '350px', overflowY: 'auto' }}>
                {table.getCoreRowModel().rows.map((row, index) => {
                    const isLastRow = index === table.getCoreRowModel().rows.length - 1;
                    const rowStyle = {
                        borderBottom: '1px solid #DFDFDF',
                        borderTop: '1px solid #DFDFDF',
                        fontSize: '13px',
                        textAlign: 'center',
                        fontWeight: isLastRow ? 'bold' : 'normal', // Conditionally set the fontWeight
                        backgroundColor: index % 2 === 0 ? '#d5e5ff' : 'white',
                    };
                    return (
                        <tr key={index} style={rowStyle}>
                            {row.getVisibleCells().map((cell, index) => {
                                const isLeftAligned = index === 0;
                                let cellValue = cell.getContext().row.original.value;
                                if (typeof cellValue === 'string') {
                                    cellValue = parseFloat(cellValue.replace(',', ''))
                                }

                                const cellStyle =
                                {
                                    borderBottom: '1px solid #DFDFDF', borderTop: '1px solid #DFDFDF', fontSize: '13px',
                                    textAlign: 'center', // Conditionally set the textAlign
                                    paddingTop: '5px',
                                    paddingBottom: '5px',
                                }
                                return (
                                    <td key={index} style={cellStyle}>
                                        <div style={{ textAlign: 'center' }}>
                                            {/* {
                                                cellValue <= 0 ?
                                                    <img src={redArrow} className='icon' alt='red circle' style={{ width: '10px', height: '7px', marginRight:'3px' }} /> :
                                                    <img src={greenArrow} className='icon' alt='red circle' style={{ width: '10px', height: '7px',  marginRight:'3px' }} />
                                            } */}
                                            <p style={{ color: cellValue <= 0 ? 'red' : 'green', textAlign: 'center' }}>
                                                {flexRender(cell.column.columnDef.cell, cell.getContext())} {props.extend}
                                            </p>
                                        </div>
                                    </td>
                                )
                            })}
                        </tr>
                    )
                })}
            </tbody>
        </table >
        // </div >
    );

}

export default IncDecTable
